import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";

interface InfoIconWithTooltipProps {
  tooltip: React.ReactNode;
}

const InfoIconWithTooltip = ({ tooltip }: InfoIconWithTooltipProps) => (
  <Tooltip title={tooltip} arrow>
    <InfoOutlinedIcon sx={{ fontSize: "16px", cursor: "help", opacity: 0.5 }} />
  </Tooltip>
);

export default InfoIconWithTooltip;
